interface ShopifyShippingLine {
  code?: string | null
  title?: string | null
}

const serviceNames: Record<string, string> = {
  usars_ground: 'Ground',
  usars_2_day_parcel: '2-Day Parcel Upgrade',
  usars_next_day_parcel: 'Next-Day Parcel Upgrade',
  usars_commercial_delivery: 'Commercial Delivery',
}

export function purchasedShippingService(shippingLinesJson?: string | null): string | null {
  if (!shippingLinesJson) return null
  try {
    const shippingLines: unknown = JSON.parse(shippingLinesJson)
    if (!Array.isArray(shippingLines)) return null
    let fallbackTitle: string | null = null
    for (const value of shippingLines) {
      if (!value || typeof value !== 'object') continue
      const line = value as ShopifyShippingLine
      const serviceName = line.code ? serviceNames[line.code] : undefined
      if (serviceName) return serviceName
      if (!fallbackTitle && line.title?.trim()) fallbackTitle = line.title.trim()
    }
    return fallbackTitle
  } catch {
    return null
  }
  return null
}
